module.exports = __webpack_public_path__ + "img/texto.af53b2a7.png";